import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export function usePageTitle() {
    const title = useSelector((state: any) => state.titleBar.title);
    const { t } = useTranslation();

    useEffect(() => {
        if (title) {
            document.title = `${t(title)} - Tactileo GO`;
        } else {
            document.title = "Tactileo GO";
        }
    }, [title]);
}